module.exports = __webpack_public_path__ + "img/faq2.16c45010.svg";